
import { CryptoJService } from "./common/crypto.service";
import { FormService } from "./common/form.service";
import { LocalyticsService } from "./common/localytics.service";
import { HttpService } from "./common/http/http.service";
import { WindowService } from "./common/window/window.service";
import { AuthenticationService } from './common/authentication.service';

import { PasswordStrengthService } from "./common/password/password.service"
import { MessageService } from "./common/message.service";
//API Service
import { RoleService } from "./role/rolelist.service";
import { GroupService } from "./group/group.service";
import { UserService } from "./user/user.service";
import { NotificationService } from "./notification/notification.service";


// Notification API Service 
import { LoginService } from "./login/login.service";

import { ModuleUtils } from "../../utils/moduleutils";

const moduleOptions: ngExtendedType.IModuleOptions = {
    injectModules: [],
    name: "Services.Module",
    services: { HttpService, LoginService, CryptoJService, FormService, RoleService, GroupService, UserService, WindowService, AuthenticationService, PasswordStrengthService, MessageService, NotificationService, LocalyticsService }
};
export let ServicesModule = ModuleUtils.CreateModule(moduleOptions);